"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.textAlignmentToCss=(e=>{switch(e){case"natural":return"start";case"left":return"left";case"right":return"right";case"center":return"center";default:throw Error(`Unsupported text alignment: ${e}`)}}),exports.textDecorationsToCss=(e=>{const t=[];return e.includes("underline")&&t.push("underline"),e.includes("strikethrough")&&t.push("line-through"),0===t.length?"none":t.join(" ")});
//# sourceMappingURL=/@diez/web-sdk-common/lib/css-typograph.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@diez/web-sdk-common/lib/css-typograph.js
// module id = 416
// module chunks = 168707334958949